









































































import { Component, Ref, Vue } from 'vue-property-decorator'

import getSearchDefine from './search'
import getModalDefine from './modal'

import { PagerData } from '@/libs/request/request'
import StoreService from '@/service/StoreService'
import service, { Genealogy } from '@/api/genealogy/Genealogy'

import IForm from '@/libs/formHelper/form/form.vue'
import IModalForm from '@/libs/formHelper/modalForm/modalForm.vue'
import IPagerTable from '@/libs/tableHelper/pagerTable.vue'
import RemoteRoleSelecter from '@/components/demo/selecter/remoteRoleSelecter.vue'
import { VillageQuery } from '@/api/village/VillageQuery'
import dayjs from 'dayjs'
import { villageChoose } from '@/components/village'
@Component({
  components: {
    IForm,
    IPagerTable,
    IModalForm,
    RemoteRoleSelecter
  }
})
export default class extends Vue {
  showModal: boolean = false;
  formItem: Genealogy = {};

  query: any = {
    page: 1,
    pageSize: 10,
    sorts: ['-createTime']
  };

  // 表格数据
  tableData: PagerData<Genealogy> = {
    total: 0,
    items: []
  };

  loading: boolean = true;

  // 村庄查询
  villageQuery: VillageQuery = {};

  get searchDefine() {
    return getSearchDefine(this)
  }

  get modalDefine() {
    return getModalDefine(this)
  }

  @Ref('modal')
  modalRef?: IModalForm<Genealogy>;

  created() {
    if (StoreService.getTypeSync() === 2) {
      this.query.villageId = StoreService.getVillageIdSync()
    }
    this.freshFromServer()
  }

  toDetailPage(data: any) {
    this.$router.push({
      name: 'genealogyDetail',
      query: {
        id: data.id
      }
    })
  }

  changeGenealogyStatus (e : Genealogy, i : number, b : number) {
    service.genealogyChoose({
      id: e.id,
      delFlag: b
    }).then((pagers) => {
      e.delFlag = b
    })
      .catch((err) => {
        this.$Message.error(err.message)
      })
  }

  fetchDataFromServer(
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }

    let loading = this.$Loading
    loading.start()
    this.loading = true
    service.getPagesOfGenealogy(this.query)
      .then((pagers) => {
        this.tableData = pagers.result!
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
      })
  }

  chooseVillageForm(formValue: any) {
    const back = (res: any) => {
      formValue.villageId = res.id
      formValue.villageName = res.name
    }
    villageChoose(back)
  }

  //  刷新当前页
  freshFromServer(): void {
    this.fetchDataFromServer()
  }

  onSearch() {
    this.fetchDataFromServer(1)
  }

  // 点击创建新的数据
  onNewItem() {
    this.modalRef && this.modalRef.openForNew({})
    // this.showModal = true
  }

  // 插入数据
  onInsertItem(dataItem: Genealogy) {
    return service.addOneGenealogy(dataItem).then(() => {
      this.$Message.success('新增成功')
      this.freshFromServer()
    })
  }

  onViewItem(dataItem: Genealogy) {
    this.modalRef && this.modalRef.openForView(dataItem)
  }

  // 点击编辑数据
  onEditItem(dataItem: Genealogy) {
    this.modalRef && this.modalRef.openForModi(dataItem)
  }

  // 更新数据
  onUpdateItem(dataItem: Genealogy) {
    return service.updateOneGenealogy(dataItem).then(() => {
      this.$Message.success('更新成功')
      this.freshFromServer()
    })
  }

  onDelItem(dataItem: Genealogy) {
    return service
      .deleteOneGenealogy(dataItem.id!)
      .then(() => {
        this.$Message.success('删除成功')
        this.freshFromServer()
      })
      .catch((error) => {
        this.$Message.error(error.message)
      })
  }

  dateHandle(date: any) {
    if (date) {
      return dayjs(date).format('YYYY-MM-DD')
    } else {
      return ''
    }
  }

  titleHandle(title: any) {
    if (title) {
      if (title.length === 1) {
        return title + '氏族谱'
      } else if (title.length === 2) {
        return title + '族谱'
      } else if (title.length === 3) {
        return title + '谱'
      }
      return title.substring(0, 4)
    } else {
      return ''
    }
  }
}
